const subDomain = 'https://support.echo360.com/hc/en-us';

export const helpUrlsLookup = {
	target: '_blank',
	helpCenter: `${subDomain}`,
	activityHelp: `${subDomain}/articles/38604348605197-Creating-an-Activity`,
	chooseActivityTypeHelp: `${subDomain}/articles/38604348605197-Creating-an-Activity`,
	activityMarkersHelp: `${subDomain}/articles/38604375445005-Creating-a-Marker-Set`,
	deprecatedLaunch: `${subDomain}/categories/37644637471373-GoReact`,
	userPermsHelp: `${subDomain}/articles/38604382411405-User-Permission-Levels`,
	chromeBugIssues: `${subDomain}/articles/38604333309581-Troubleshooting-recording`,
	rubricHelp: `${subDomain}/articles/38604376395405-Creating-a-Rubric`,
	studentRubrics: `${subDomain}/articles/38604376395405-Creating-a-Rubric`,
	videoRecordingList: `${subDomain}/articles/38604362306445-Video-Recording-Checklist`,
	recordVideoTroubleshoot: `${subDomain}/articles/38604333309581-Troubleshooting-recording`,
	videoTroubleshoot: `${subDomain}/articles/38604333291789-Enabling-your-camera-and-microphone`,
	cameraTroubleshoot: `${subDomain}/articles/38604333512205-Troubleshooting-Camera-Microphone-Connections1`,
	microphoneTroubleshoot: `${subDomain}/articles/38604375877645-Troubleshooting-audio`,
	supportedBrowserTroubleshoot: `${subDomain}/articles/38604376797325-Updating-your-browser`,
	networkTroubleshoot: `${subDomain}/articles/38604361830285-Network-requirements`,
	sourceMediaHelp: `${subDomain}/articles/38604333707405-Stimulus-Activities`,
	captions: `${subDomain}/articles/38604382823693-Enabling-Closed-Captions-and-Uploading-Audio-Description-Files`,
	cameraFixHelp: `${subDomain}/articles/38604333512205-Troubleshooting-Camera-Microphone-Connections`,
	submitSupportRequest: `${subDomain}/categories/37644637471373-GoReact`,
	inviteHelp: `${subDomain}/articles/38604382411405-User-Permission-Levels`,
	security: `${subDomain}/articles/38459181725325-Compliance-Privacy-Security-and-Accessibility`,
	contactSupport: `${subDomain}/categories/37644637471373-GoReact`,
	lmsIntegrationDetails: `${subDomain}/articles/38459227848845-LMS-Integration-Details`,
	blackboardSetup: `${subDomain}/articles/38604331019021-Administrator-setup-of-GoReact-in-Blackboard-Learn-2016`,
	brightspaceSetup: `${subDomain}/articles/38604330725517-Administrator-setup-of-GoReact-in-Brightspace`,
	canvasSetup: `${subDomain}/sections/38436763878925-Administrators`,
	moodleSetup: `${subDomain}/articles/38604349141389-Administrator-Setup-of-GoReact-in-Moodle`,
	schoologySetup: `${subDomain}/articles/38604366464653-Adding-GoReact-to-Schoology`,
	instructorHelp: `${subDomain}/sections/38436732050317-Instructors-Owners`,
	feedbackHold: `${subDomain}/articles/38604332996877-Feedback-Hold`,
	multipleCameras: `${subDomain}/articles/38604333936013-Group-Recording-Activities`,
	accessibility: `${subDomain}/articles/38604376013581-VPAT-2-4-508-Compliance`,
	masterActivity: `${subDomain}/articles/38604349889293-Master-Activity-Sync`
};
